import { router, useLocalSearchParams } from "expo-router";
import React, { useEffect } from "react";
import { ActivityIndicator, View } from "react-native";

import { surface } from "@/src/theme/tokens";

/**
 * Retired UID-scoped group-conversation route.
 *
 * Future group messaging is keyed by groupId and public identity. Keep this
 * route only as a lightweight redirect so old internal links cannot revive the
 * legacy conversation model.
 */
export default function RetiredLegacyGroupConversationRoute() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const groupId = String(id || "");

  useEffect(() => {
    if (!groupId) {
      router.replace("/(tabs)/messages");
      return;
    }
    router.replace({
      pathname: "/(tabs)/messages/group-thread/[id]",
      params: { id: groupId },
    });
  }, [groupId]);

  return (
    <View style={{ flex: 1, alignItems: "center", justifyContent: "center", backgroundColor: surface.secondary }}>
      <ActivityIndicator />
    </View>
  );
}
